// extracted by mini-css-extract-plugin
export default {"container":"for_3_-fX","loading":"for_loa_14qXb","loadingIcon":"for_loa_3pW3b","spin":"for_spi_2Y5UF","colored":"for_col_3U_nA"};